<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<main class="main-view columns no-top-panel">
			<div class="column">
				<div class="title">
					{{ checklistId != 0 ? "Editera" : "Ny" }} checklista
					{{
						localQuestionList.company && localQuestionList.customer
							? ` - ${localQuestionList.company.name} ${localQuestionList.customer.name}`
							: " - Allmän"
					}}
				</div>
				<div class="top-box" :style="mobile">
					<div class="row">
						<div class="field name">
							<label class="label">Namn</label>
							<div class="control">
								<textarea
									v-model="localQuestionList.name"
									class="textarea no-resize"
									rows="2"
									placeholder="Checklistans namn"
								/>
							</div>
						</div>
						<div class="field description">
							<label class="label">Beskrivning</label>
							<div class="control">
								<textarea
									v-model="localQuestionList.description"
									class="textarea no-resize"
									rows="2"
									placeholder="Checklistans beskrivning"
								/>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="field" v-if="$isAllowedTo('global_set_object_as_global')">
							<label class="label">Allmän</label>
							<SwitchButton v-model="globalVisibility" />
						</div>
					</div>

					<div class="buttons">
						<button
							class="button is-info"
							:class="loading ? 'is-loading' : ''"
							@click="save"
						>
							<span class="icon is-white"><i class="fas fa-save"/></span
							><span>Spara</span>
						</button>
						<button class="button is-dark" @click="cancel" v-if="!isMobile">
							<span class="icon"><i class="fas fa-backward"/></span>
							<span>Tillbaka</span>
						</button>
					</div>
				</div>
				<div class="columns" v-if="showList && savedList">
					<AddList
						:questionGroups="listQuestionGroups"
						:questions="questions"
						@addQuestion="addQuestion"
						@updateSelected="updateSelected"
						@searchGroups="getListQuestionGroups"
					/>
					<ListQuestions
						:selectedQuestionGroups="selectedQuestionGroups"
						:questionGroups="listQuestionGroups"
						@removeQuestion="askToRemove"
					/>
				</div>
				<div class="no-list" v-else>
					<p class="subtitle">Spara listan för att kunna lägga till frågor</p>
				</div>
			</div>
		</main>
		<DeleteModal
			v-if="showDelete"
			@confirm="removeQuestion"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddList from './components/AddList';
import ListQuestions from './components/ListQuestions';
import DeleteModal from '@/components/DeleteModal';
import SwitchButton from '@/components/switchButton';

export default {
	components: {
		AddList,
		ListQuestions,
		DeleteModal,
		SwitchButton
	},
	data() {
		return {
			showList: false,
			localQuestionList: {
				company: null,
				customer: null
			},
			selectedQuestionGroup: { questions: [] },
			selectedQuestions: [],
			checklistId: 0,
			questionToRemove: {},
			showDelete: false,
			loading: false,
			disableCustomerDropdown: false,
			globalVisibility: false
		};
	},
	computed: {
		...mapGetters('questionGroupStore', ['listQuestionGroups']),
		...mapGetters('questionListStore', ['questionList']),
		...mapGetters('questionStore', ['question']),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('user', ['getUser', 'getActiveCompany', 'getActiveCustomer']),

		deleteMessage() {
			return this.questionToRemove.name
				? `Är du säker på att du vill ta bort ${this.questionToRemove.name}?`
				: '';
		},
		savedList() {
			return this.localQuestionList.id || false;
		},
		selectedQuestionGroups() {
			function groupBy(arr, groupByKeyFn) {
				return arr.reduce((acc, c) => {
					var key = groupByKeyFn(c);
					acc[key] = acc[key] || [];
					acc[key].push(c);

					return acc;
				}, []);
			}

			if (this.checklistId != 0) {
				let questions = this.selectedQuestions;
				let questionGroups = groupBy(
					questions,
					question => question.questionGroupId
				);
				let indexArray = [];
				for (var item in questionGroups) {
					indexArray.push({
						id: questionGroups[item][0].questionGroupId,
						questions: questionGroups[item]
					});
				}

				return indexArray;
			}

			return [];
		},
		questions() {
			let questions = [];

			if (this.selectedQuestionGroup) {
				questions = this.selectedQuestionGroup.questions || [];
			}

			console.log(this.selectedQuestionGroup);

			const isSameId = element => element.id == this.selectedQuestionGroup.id;
			let groupIndex = this.selectedQuestionGroups.findIndex(isSameId);

			function comparer(otherArray) {
				return function(current) {
					return (
						otherArray.filter(function(other) {
							return other.id === current.id;
						}).length === 0
					);
				};
			}

			if (groupIndex !== -1) {
				let groupQuestions = this.selectedQuestionGroups[groupIndex].questions;
				let newQuestions = questions.filter(comparer(groupQuestions));

				return newQuestions;
			}

			return questions;
		},
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.$router.push({ name: 'ChecklistView' });
		}
	},

	methods: {
		...mapActions('questionGroupStore', ['getListQuestionGroups']),
		...mapActions('questionListStore', [
			'getQuestionList',
			'updateQuestionList',
			'createQuestionList',
			'setQuestionList'
		]),
		...mapActions('questionStore', ['updateQuestion', 'getQuestion']),
		addQuestion(question) {
			let index = question.questionListIds.indexOf(this.checklistId);
			this.selectedQuestions.push(question);

			// Get the question from the database because we don't get the questionListIds included in the questions when getting questionGroups
			this.getQuestion(question.id).then(() => {
				question = Object.assign({}, this.question);

				if (index === -1) {
					if (!question.questionListIds) {
						question.questionListIds = [];
					}

					let localQuestion = Object.assign({}, question);
					localQuestion.questionListIds.push(this.checklistId);
					this.updateQuestion(localQuestion).then(() => {
						this.refresh();
					});
				}
			});
		},
		askToRemove(question) {
			this.questionToRemove = question;
			this.showDelete = true;
		},
		cancelDelete() {
			this.showDelete = false;
		},
		removeQuestion() {
			this.showDelete = false;

			// Get the question from the database because we don't get the questionListIds included in the questions when getting questionGroups
			this.getQuestion(this.questionToRemove.id).then(() => {
				let index = this.question.questionListIds.indexOf(this.checklistId);

				if (index !== -1) {
					this.question.questionListIds.splice(index, 1);
				}

				this.updateQuestion(this.question).then(() => {
					this.showDelete = false;
					this.refresh();
				});
			});
		},
		async refresh() {
			this.getQuestionList(this.checklistId).then(() => {
				this.selectedQuestions = this.questionList.questions;
			});

			this.selectedQuestionGroup = await this.$services.questionGroup.getQuestionGroup(this.selectedQuestionGroup.id);
		},
		updateSelected(questionGroup) {
			this.selectedQuestionGroup = questionGroup;
		},
		save() {
			this.loading = true;

			this.localQuestionList.companyId = this.globalVisibility ? null : this.getActiveCompany.id;
			this.localQuestionList.customerId = this.globalVisibility ? null : this.getActiveCustomer.id;

			if (this.localQuestionList.id) {
				this.localQuestionList.questionIds = [];
				this.selectedQuestions.forEach(question => {
					this.localQuestionList.questionIds.push(question.id);
				});
				this.updateQuestionList(this.localQuestionList)
					.then(() => {
						this.loading = false;
						this.setQuestionList(this.localQuestionList);
					})
					.catch(err => {
						console.log(err);
						this.loading = false;
					});
			} else {
				this.createQuestionList(this.localQuestionList)
					.then(result => {
						this.localQuestionList = Object.assign({}, result);
						this.checklistId = this.localQuestionList.id;
						this.loading = false;
						this.$router.replace({
							name: 'ChecklistDetailView',
							params: { checklistId: this.checklistId }
						});

						this.setQuestionList(result);
					})
					.catch(err => {
						console.log(err);
						this.loading = false;
					});
			}
		},
		cancel() {
			this.$router.push('/checklists');
		},
		handleCompanySearch() {},
		handleCustomerSearch() {}
	},

	async created() {
		this.setQuestionList({});

		this.checklistId = this.$route.params.checklistId;
		this.getListQuestionGroups().then(() => {
			this.selectedQuestionGroup = this.listQuestionGroups[0];
			this.showList = true;
		});

		if (this.checklistId != 0) {
			await this.getQuestionList(this.checklistId);

			this.localQuestionList = Object.assign({}, this.questionList);
			this.selectedQuestions = this.questionList.questions;
		}

		if (!this.$isAllowedTo('global_set_object_as_global') && this.checklistId == 0) {
			try {
				let companyRes = await this.$services.company.getCompany(this.getActiveCompany.id);
				this.localQuestionList.company = companyRes;

				let customer = await this.$services.customer.getCustomer(this.getActiveCustomer.id);
				this.localQuestionList.customer = customer;

			} catch (error) {
				console.log(error);
			}
		}

		if (this.checklistId != 0)
			this.globalVisibility = this.$isAllowedTo('global_set_object_as_global') && this.localQuestionList.company == null;
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.column .title {
  margin-bottom: 16px;
}
.top-box {
  background: $lightest-grey;
  padding: 10px 5px 10px 5px;
  display: block;
  border-radius: 2px;
  margin-bottom: 10px;

  .field {
    margin-left: 10px;
    margin-right: 10px;

    &.name {
      flex: 1;
    }

    &.description {
      flex: 2;
    }

    .label {
      font-size: 12px;
    }

    &.select.is-multiple {
      flex-grow: 1;
      max-width: 250px;
    }
  }

  .textarea {
    background: white;
    border-radius: 2px;
  }

  .buttons {
    margin: 2rem 10px 0 10px;
    display: flex;
    justify-content: space-between;
    flex-flow: row-reverse;

    .button {
      border-radius: 2px;
      width: 110px;
    }
  }

  .row {
    display: flex;
    position: relative;
  }
}
.no-list {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid $lightest-grey;
  text-align: center;
}
</style>
